export default __webpack_public_path__ + "static/media/3.b77b3002.jpeg";